import React from 'react';
import { ArrowDown, ArrowUp } from 'lucide-react';
import { StatusBadge, DirectionLabel } from './StatusBadge';
import { ExpectedCell, LastEvent, PartyCell, RowTags, TrackingCell } from './ShipmentCells';
import { rowTone } from '../../utils/shipmentsFormat';
import { useRowOpen } from './useRowOpen';

// Clicking anywhere in a row opens the detail; the number inside is a real link for the keyboard and middle click.

// Column headers that sort the list (contract: sort = lastEvent | created | expected | status | carrier)
const SortHeader = ({ label, field, sort, order, onSort }) => {
  const active = sort === field;
  const Icon = order === 'asc' ? ArrowUp : ArrowDown;
  return (
    <th scope="col" aria-sort={active ? (order === 'asc' ? 'ascending' : 'descending') : undefined}>
      <button type="button" onClick={() => onSort(field)} aria-label={`Řadit podle: ${label}`}>
        {label} {active && <Icon size={13} aria-hidden="true" />}
      </button>
    </th>
  );
};

const ShipmentTable = ({ rows, sort, order, onSort }) => {
  const openRow = useRowOpen();
  return (
    <div className="shp-card shp-card--flush shp-tablewrap">
      <table className="shp-table">
        <caption className="shp-sr">Seznam zásilek</caption>
        <thead>
          <tr>
            <SortHeader label="Stav" field="status" sort={sort} order={order} onSort={onSort} />
            <SortHeader label="Zásilka" field="carrier" sort={sort} order={order} onSort={onSort} />
            <th scope="col">Směr</th>
            <th scope="col">Zákazník / dodavatel</th>
            <SortHeader label="Očekáváno" field="expected" sort={sort} order={order} onSort={onSort} />
            <SortHeader label="Poslední událost" field="lastEvent" sort={sort} order={order} onSort={onSort} />
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id} className={`shp-row ${rowTone(row) ? `shp-row--${rowTone(row)}` : ''}`} onClick={openRow(row.id)}>
              <td>
                <div className="shp-statuscell">
                  <StatusBadge status={row.status} />
                  <RowTags row={row} />
                </div>
              </td>
              <td className="shp-col-trk"><TrackingCell row={row} description={row.description} /></td>
              <td><DirectionLabel direction={row.direction} /></td>
              <td style={{ maxWidth: 220 }}><PartyCell row={row} /></td>
              <td><ExpectedCell row={row} /></td>
              <td><LastEvent at={row.lastEventAt} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShipmentTable;
